import { FC, CSSProperties } from 'react';
// 组件
import { ProSpin } from '../../antd';
// 常量
import { SpinProps } from 'antd/lib/spin';

export interface LoadingProps extends SpinProps {
  style?: CSSProperties;
}

const Loading: FC<LoadingProps> = props => {
  const { spinning, style, ...resProps } = props;
  if (!spinning) return null;
  return (
    <div className="root-loading-wrapper" style={style}>
      <ProSpin spinning={spinning} {...resProps} />
    </div>
  );
};

export default Loading;
